// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onfido-sdk-ui-PhoneNumberInput-flagIcon{background-size:100%;background-repeat:no-repeat;background-position:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flagIcon": "onfido-sdk-ui-PhoneNumberInput-flagIcon"
};
export default ___CSS_LOADER_EXPORT___;
